import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';

const FilterMenuV2 = ({ children, openFilterMenu, setOpenFilterMenu }) => {

  return (
    <div>
      <Button onClick={() =>
        setOpenFilterMenu(true)
      }>Filtri</Button>
      <ClickAwayListener
        mouseEvent="onMouseDown"
        touchEvent="onTouchStart"
        open={openFilterMenu}
        onClickAway={() => openFilterMenu && setOpenFilterMenu(false)}
      >
        <Drawer variant="persistent"
          anchor="left"
          open={openFilterMenu}
        >
          <Box sx={{ width: 500 }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
              <IconButton onClick={() => setOpenFilterMenu(false)}>
                {openFilterMenu ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
            <Divider />
            <Typography variant="h1" gutterBottom align="center">
              Filtri
            </Typography>
            {children}
          </Box>
        </Drawer>
      </ClickAwayListener>
    </div >
  );
}

export default FilterMenuV2;